// employee/reducers.ts
const initialState = {
    getSettingsData: [],
    updateUserCredentialsData: [],
    createSettingsData: null,
    updateSettingsData: null,
    getSettingsMetaMessage: null,
    getUserCredentialsMetaMessage: null,
    getSettingsSuccess: false,
    getSettingsFailure: false,
    createSettingsSuccess: false,
    createSettingsFailure: false,
    updateSettingsSuccess: false,
    updateSettingsFailure: false,

    updateUserCredentialsSuccess: false,
    updateUserCredentialsFailure: false,

    deleteSettingsSuccess: false,
    deleteSettingsFailure: false,
};

export default function SettingsReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_SETTINGS_SUCCESS': {
            return {
                ...state,
                getSettingsSuccess: true,
                getSettingsData: action.payload?.data?.data?.data,
                getSettingsFailure: false,
            };
        }
        case 'GET_SETTINGS_FAILURE': {
            return {
                ...state,
                getSettingsFailure: true,
                getSettingsMetaMessage: action.payload?.data?.data?.meta?.message,
                getSettingsSuccess: false,
            };
        }
        case 'RESET_GET_SETTINGS': {
            return {
                ...state,
                getSettingsSuccess: false,
                getSettingsFailure: false,
                getSettingsData: [],
                getSettingsMetaMessage: null,
            };
        }

        case 'CREATE_SETTINGS_SUCCESS': {
            return {
                ...state,
                createSettingsSuccess: true,
                createSettingsData: action.payload?.data?.data?.data,
                getSettingsMetaMessage: action.payload?.data?.data?.meta?.message,
                createSettingsFailure: false,
            };
        }
        case 'CREATE_SETTINGS_FAILURE': {
            return {
                ...state,
                createSettingsFailure: true,
                getSettingsMetaMessage: action.payload?.data?.data?.meta?.message,
                createSettingsSuccess: false,
            };
        }
        case 'RESET_CREATE_SETTINGS': {
            return {
                ...state,
                createSettingsSuccess: false,
                createSettingsFailure: false,
                createSettingsData: null,
                getSettingsMetaMessage: null,
            };
        }

        case 'UPDATE_SETTINGS_SUCCESS': {
            return {
                ...state,
                updateSettingsSuccess: true,
                updateSettingsData: action.payload?.data?.data?.data,
                getSettingsMetaMessage: action.payload?.data?.data?.meta?.message,
                updateSettingsFailure: false,
            };
        }
        case 'UPDATE_SETTINGS_FAILURE': {
            return {
                ...state,
                updateSettingsFailure: true,
                getSettingsMetaMessage: action.payload?.data?.data?.meta?.message,
                updateSettingsSuccess: false,
            };
        }
        case 'RESET_UPDATE_SETTINGS': {
            return {
                ...state,
                updateSettingsSuccess: false,
                updateSettingsFailure: false,
                updateSettingsData: null,
                getSettingsMetaMessage: null,
            };
        }

        // User Credentials

        case 'UPDATE_USER_CREDENTIALS_SUCCESS': {
            return {
                ...state,
                updateUserCredentialsSuccess: true,
                updateUserCredentialsData: action.payload?.data?.data?.data,
                getUserCredentialsMetaMessage: action.payload?.data?.data?.meta?.message,
                updateUserCredentialsFailure: false,
            };
        }
        case 'UPDATE_USER_CREDENTIALS_FAILURE': {
            return {
                ...state,
                updateUserCredentialsFailure: true,
                getUserCredentialsMetaMessage: action.payload?.data?.data?.meta?.message,
                updateUserCredentialsSuccess: false,
            };
        }
        case 'RESET_UPDATE_USER_CREDENTIALS': {
            return {
                ...state,
                updateUserCredentialsSuccess: false,
                updateUserCredentialsFailure: false,
                updateUserCredentialsData: null,
                getUserCredentialsMetaMessage: null,
            };
        }

        // case 'DELETE_SETTINGS_SUCCESS': {
        //     return {
        //         ...state,
        //         deleteSettingsSuccess: true,
        //         getSettingsMetaMessage: action.payload?.data?.data?.meta?.message,
        //         deleteSettingsFailure: false,
        //     };
        // }
        // case 'DELETE_SETTINGS_FAILURE': {
        //     return {
        //         ...state,
        //         deleteSettingsFailure: true,
        //         getSettingsMetaMessage: action.payload?.data?.data?.meta?.message,
        //         deleteSettingsSuccess: false,
        //     };
        // }
        // case 'RESET_DELETE_SETTINGS': {
        //     return {
        //         ...state,
        //         deleteSettingsSuccess: false,
        //         deleteSettingsFailure: false,
        //         getSettingsMetaMessage: null,
        //     };
        // }

        default: {
            return state;
        }
    }
}
